export default __webpack_public_path__ + "static/media/image3.f2c84e80.png";